export class CanaisComunicacaoWhatsAppChatSticker {
  public stickerUrl: string;
  public mimeType: string;

  constructor() { }
}
